// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import { Element } from 'react-scroll';
import * as Markdown from '../../../components/Markdown';
import Collapse from '../../../components/Collapse';
import { NAVIGATION_TOP_OFFSET } from './Navigation';
import styled from 'styled-components';

interface CollapseMarkdownProps extends React.ComponentPropsWithRef<'div'> {
  markdown: string;
  baseUrl?: string;
  index: number;
  currentIndex: number;
  isClickNavigation: boolean;
  labPassword?: string;
  onExpanded: () => void;
}

const TitleMarkdown = styled(Markdown.LabMarkdown)`
  margin-bottom: 12px;
`

const CollapseMarkdown = (props: CollapseMarkdownProps): JSX.Element => {
  const {
    markdown,
    baseUrl,
    index,
    currentIndex,
    isClickNavigation,
    labPassword,
    onExpanded,
    ...otherProps
  } = props;
  const [isShow, setShow] = useState(true);

  useEffect(() => {
    // markdown index start from 1
    if (isClickNavigation && index + 1 === currentIndex) {
      setShow(false);
    }
  }, [isClickNavigation]);

  useEffect(() => {
    if (!isShow) {
      setShow(true);
      onExpanded();
    }
  }, [isShow])

  const breaklineIndex = markdown.indexOf('\n') !== -1 ? markdown.indexOf('\n') : markdown.length;
  const titleMarkdown = markdown.slice(0, breaklineIndex);
  const contentMarkdown = markdown.slice(breaklineIndex + 1);

  const renderTitle = () => {
    return (
      <Element name={`m-${index + 1}`}>
        <TitleMarkdown markdown={titleMarkdown} />
      </Element>
    )
  }

  return (
    <Collapse isShow={isShow} key={index} title={renderTitle} {...otherProps}>
      <Markdown.LabMarkdown markdown={contentMarkdown} baseUrl={baseUrl} labPassword={labPassword}/>
    </Collapse>
  )
}

const S = {
  CollapseMarkdown: styled(CollapseMarkdown)`
    & {
      margin-top: 24px;
      border-top: 2px solid #DEDEDE;
      padding-top: 24px;

      button {
        top: 24px;
      }
    }
  `,
}

interface LabMarkdownProps extends React.ComponentProps<'div'> {
  markdowns: string[];
  isNavigationScrolling: boolean;
  currentIndex: number;
  onExpanded: () => void;
  isClickNavigation: boolean;
  onIndexChange: (step: number) => void;
  labPassword?: string;
  baseUrl?: string;
}

const LabMarkdown = (props: LabMarkdownProps): JSX.Element => {
  const {
    markdowns,
    isNavigationScrolling,
    currentIndex,
    onExpanded,
    isClickNavigation,
    labPassword,
    onIndexChange,
    baseUrl
  } = props;

  const handleScroll = () => {
    if (isNavigationScrolling || markdowns.length === 0) {
      return;
    }

    const items = markdowns
      .map((_, index) => ({
        index: index + 1, // markdowns start from 1 becasue of overview is 0
      }))
      .map(({ index }) => ({
        index,
        el: document.querySelector(`[name="m-${index}"]`) as unknown as globalThis.Element
      }))
      .map(({ index, el }) => ({
        index,
        top: el.getBoundingClientRect().top + NAVIGATION_TOP_OFFSET
      }))

    let currentItem = items[0]

    items.forEach(item => {
      if (item.top <= 0) {
        if (item.top > currentItem.top) {
          currentItem = item;
        }
      }
    });

    onIndexChange(currentItem.top <= 0 ? currentItem.index : 0); // rollback to overview or not
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [markdowns, isNavigationScrolling, isClickNavigation]);

  return (
    <>{markdowns.map((markdown, index) =>
      <S.CollapseMarkdown
        key={index}
        markdown={markdown}
        baseUrl={baseUrl}
        index={index}
        isClickNavigation={isClickNavigation}
        currentIndex={currentIndex}
        onExpanded={onExpanded}
        labPassword={labPassword}
      />)
    }
    </>
  )
}

export default LabMarkdown;
